import { APICapability } from "../../../../types/global";

export const API_CAPABILITIES = [
    "Create Link",
    "Retrieve Link",
    "Delete Link",
    "Edit Link",
    "Create Customer",
    "Delete Customer",
    "Edit Customer",
    "Retrieve Customer"
] as APICapability[]